import {Button, Col} from "react-bootstrap";
import {useNavigate} from "react-router-dom";

const ErrorPage = () => {
    const navigate = useNavigate();
    return (
        <Col className={'border-1 border-black iframe-container'} md={4} sm={12}>
            <div className={'text-center d-block w-100 mt-md-5 pt-md-5 pt-2'}>
                <h3>Oops.. Algo salió mal</h3>
                <p>Estamos revisando que pasó 🧑‍🔧</p>
                <Button onClick={() => {
                    navigate('/booking')
                }} className={'mt-2 back-to-home-button w-100'}>Volver al Inicio</Button>
            </div>
        </Col>
    );
}
export default ErrorPage;